// +----------------------------------------------------------------------
// | websocket
// +----------------------------------------------------------------------
// | Copyright (c) 2018 安徽秒速科技有限公司 All rights reserved.
// +----------------------------------------------------------------------
// | Author：tangfei <957987132@qq.com>
// +----------------------------------------------------------------------
// | 启动服务器 php /Users/tangfei/workspace/tp51/workerman/server.php start
// +----------------------------------------------------------------------
import Vue from "vue";
import appConfig from "@/config/app"; //引入配置文件
import ReconnectingWebSocket from "reconnecting-websocket";

//是否开启ajax debug模式
const debug = appConfig.websocket.options.debug;

const socket = {
  //公共参数
  data: {
    ws: null, //实例
    heatbeat: null //心跳定时器
  },

  //初始化
  init(uid, tokey, onopen, onmessage, onclose, onerror) {
    //实例化
    socket.data.ws = new ReconnectingWebSocket(
      appConfig.websocket.host+uid+"/"+tokey,
      appConfig.websocket.protocols,
      appConfig.websocket.options
    );

    //连接建立时触发
    socket.data.ws.onopen = function(e) {
      //心跳检测重置
      socket.heartCheck.reset().start();
      socket.errorCode(200);
      if (typeof onopen == "function") onopen(e);
    };

    //客户端接收服务端数据时触发
    socket.data.ws.onmessage = function(e)
    {
      //如果获取到消息，心跳检测重置 ，拿到任何消息都说明当前连接是正常的
      socket.heartCheck.reset().start();
      //判断是否json对象
      if (Vue.prototype.$func.isJSON(e.data)) {
        //接收数据
        let ret = JSON.parse(e.data);
        if (typeof onmessage == "function") onmessage(ret);
      }
    };

    //连接关闭时触发
    socket.data.ws.onclose = function(e) {
      if (debug) socket.errorCode(e.code);
      if (typeof onclose == "function") onclose(e);
    };

    //通信发生错误时触发
    socket.data.ws.onerror = function(e) {
      if (debug) socket.errorCode(-1);
      if (typeof onerror == "function") onerror(e);
    };
  },

  //心跳检测 50秒发一次 保持长连接
  heartCheck:{
    timeout: 60000 * 3, //3 分钟
    timeoutObj: null,
    serverTimeoutObj: null,
    reset: function() {
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
      return this;
    },
    start: function() {
      let self = this;
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage 拿到返回的心跳就说明连接正常
        socket.sendMessage("HeartBeat");
        //如果超过一定时间还没重置
        self.serverTimeoutObj = setTimeout(function () {
          //说明后端主动断开了
          socket.closeSocket(); //如果 onclose 会执行 reconnect，我们执行 ws.close()就行了. 如果直接执行 reconnect 会触发 onclose 导致重连两次
        }, self.timeout)
      }, self.timeout)
    }
  },

  //使用连接发送数据
  sendMessage(content, fn) {
    //必须存在实例
    if (socket.data.ws != null) {
      //发送前判断连接状态
      const state = socket.data.ws.readyState;
      if (state === 1) {//正常
        //发送数据
        socket.data.ws.send(content);
      } else {
        //断开
        socket.msgTip(socket.isLink(state));
        if (typeof fn == "function") fn();
      }
    } else {
      socket.msgTip(socket.isLink(0));
      if (typeof fn == "function") fn();
    }
  },

  //关闭连接
  closeSocket() {
    socket.data.ws.close();
  },

  //自定义通讯方法
  on(
    that,
    api_url = "",
    data = {},
    callback = {
      //数据接收
      success: null, //成功回调
      error: null, //失败回调
      common: null, //公共回调
      senderror: null //消息发送失败回调
    }
  ) {
    //连接建立时触发
    socket.onOpen = function(e) {
      if (typeof that.wsOpen == "function") that.wsOpen(e);
    };
    //客户端接收服务端数据时触发
    socket.onMessage = function(e) {
      if (typeof that.wsMessage == "function") that.wsMessage(e);
    };
    //关闭连接
    socket.onClose = function(e) {
      if (typeof that.wsClose == "function") that.wsClose(e);
    };
    //通信发生错误时触发
    socket.onError = function(e) {
      if (typeof that.wsError == "function") that.wsError(e);
    };

    //发送数据
    socket.sendMessage(api_url.url, data, function() {
      //错误回调
      if (typeof callback.senderror == "function")
        callback.senderror(socket.data.ws);
    });

    //客户端接收服务端数据时触发
    socket.onMessage = function(ret) {
      //是否开启 debug
      if (debug) {
        console.log(
          `%c 接口描述：%c ${api_url.description} %c`,
          "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
          "background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
          "background:transparent"
        );
        console.log(
          `%c请求地址：%c ${
            api_url.url.app
              ? api_url.url.app +
                "-" +
                api_url.url.model +
                "-" +
                api_url.url.action
              : api_url.url
          } %c`,
          "font-weight:bold",
          "",
          ""
        );
        console.log(
          `%c请求参数：%c ${JSON.stringify(data)} %c`,
          "font-weight:bold",
          "",
          ""
        );
      }
      if (ret.code) {
        //正常回调
        if (typeof callback.success == "function")
          callback.success(ccccc.data.ws, ret);
      } else {
        //错误回调
        if (typeof callback.error == "function")
          callback.error(socket.data.ws, ret);
      }
      //公共回调
      if (typeof callback.common == "function")
        callback.common(socket.data.ws, ret);
      if (debug)
        console.log(
          `%c接口返回：%c ${JSON.stringify(ret.data)} %c`,
          "font-weight:bold",
          "",
          ""
        );
    };
  },

  //错误提示
  msgTip(desc, title) {
    Vue.prototype.$Notice.error({
      title: title || "webSocket服务器提示",
      desc: desc
    });
  },

  //发送消息前判断连接状态
  isLink(state) {
    var msg = "";
    switch (state) {
      case 0:
        msg = "连接尚未建立";
        break;
      case 1:
        msg = "连接已建立，可以进行通信";
        break;
      case 2:
        msg = "连接正在进行关闭";
        break;
      case 3:
        msg = "连接已经关闭或者连接不能打开";
        break;
    }
    return msg;
  },

  //错误编号
  errorCode(code) {
    var msg = "";
    switch (code) {
      case -1:
        msg = "服务器连接失败，部分功能无法使用，请联系客服人员！";
        break;
      case 200:
        msg = "连接成功";
        break;
      case 1000:
        msg = "正常关闭";
        break;
      case 1001:
        msg =
          "终端离开, 可能因为服务端错误, 也可能因为浏览器正从打开连接的页面跳转离开";
        break;
      case 1002:
        msg = "由于协议错误而中断连接";
        break;
      case 1003:
        msg =
          "由于接收到不允许的数据类型而断开连接 (如仅接收文本数据的终端接收到了二进制数据)";
        break;
      case 1005:
        msg = "没有收到预期的状态码";
        break;
      case 1006:
        msg = "连接非正常关闭";
        break;
      case 1007:
        msg =
          "由于收到了格式不符的数据而断开连接 (如文本消息中包含了非 UTF-8 数据)";
        break;
      case 1008:
        msg =
          "由于收到不符合约定的数据而断开连接。 这是一个通用状态码, 用于不适合使用 1003 和 1009 状态码的场景";
        break;
      case 1009:
        msg = "由于收到过大的数据帧而断开连接";
        break;
      case 1010:
        msg =
          "客户端期望服务器商定一个或多个拓展, 但服务器没有处理, 因此客户端断开连接";
        break;
      case 1011:
        msg = "客户端由于遇到没有预料的情况阻止其完成请求, 因此服务端断开连接";
        break;
      case 1012:
        msg = "服务器由于重启而断开连接";
        break;
      case 1013:
        msg =
          "服务器由于临时原因断开连接, 如服务器过载因此断开一部分客户端连接";
        break;
      case 1015:
        msg = "连接由于无法完成 TLS 握手而关闭";
        break;
      default:
        msg = "未知错误";
        break;
    }
    //是否开启 debug
    if (debug) console.log(msg);
    return msg;
  }
};

export default socket;
